import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspacePracticedCertifiedItemsCountParams {
  days_ago: number;
  include_previous_period?: boolean;
  include_top_workspace_check?: boolean;
}

export interface IFetchWorkspacePracticedCertifiedItemCountResponse {
  practiced_certified_item_count: string;
  previous_period_practiced_certified_item_count: string;
  top_half_of_all_workspaces: boolean;
  top_third_of_all_workspaces: boolean;
}

export default function useFetchWorkspacePracticedCertifiedItemsCount({
  days_ago,
  include_previous_period = false,
  include_top_workspace_check = false,
}: IFetchWorkspacePracticedCertifiedItemsCountParams): UseQueryResult<
  IFetchWorkspacePracticedCertifiedItemCountResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspacePracticedCertifiedItemCountResponse>(
    [
      "workspace-certified-items-practiced-count",
      {
        days_ago,
        include_previous_period,
        include_top_workspace_check,
      },
    ],
    async (): Promise<IFetchWorkspacePracticedCertifiedItemCountResponse> => {
      return await axios
        .get(
          `/v1/workspaces/practice-sets/sessions/certified-items-practiced-count`,
          {
            params: {
              days_ago,
              include_previous_period,
              include_top_workspace_check,
            },
          }
        )
        .then((r) => {
          return r.data as IFetchWorkspacePracticedCertifiedItemCountResponse;
        });
    }
  );

  return query;
}
